import { apiClientBudgetStatuses } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'client-budget-statuses';

const config = [
  { actionType: 'getAll', apiPath: `${apiClientBudgetStatuses}`, method: get },
  {
    actionType: 'getOne',
    apiPath: (params: Params) => `${apiClientBudgetStatuses}/${params.id}`,
    method: get,
  },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
